export interface IconProps {
  size?: number;
  stroke?: string;
  className?: string;
  strokeWidth?: number;
}

const ChevronLeftIcon = ({
  size = 24,
  stroke = 'currentColor',
  className,
  strokeWidth = 3,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="m15 18-6-6 6-6" />
  </svg>
);

export default ChevronLeftIcon;
